<div class="surface-section px-4 py-8 md:px-6 lg:px-8">
    <div class="mt-6 mb-5 font-bold text-6xl text-900 text-center"></div>
    <p class="text-700 text-3xl mt-0 mb-6 text-center">Authenticating, please wait ... </p>
</div>
